import { TipoDespesa, TipoDocumento } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment';


@Injectable({
    providedIn: 'root'
})

export class TipoService {

    obterTiposDocumentoNaoFiscal(): Observable<any> {
        return this.http.get<TipoDocumento[]>(`${environment.apiUrl}/api/tipo/documento/naofiscal`);
    }

    obterTiposDocumentoFiscal(): Observable<any> {
        return this.http.get<Array<TipoDocumento>>(`${environment.apiUrl}/api/tipo/documento/fiscal`);
    }

    getTipoDespesas(tipoDoc: string): Observable<any> {
        return this.http.get<TipoDespesa[]>(`${environment.apiUrl}/api/tipo/despesas?tipoDocumento=` + tipoDoc);
    }

    constructor(private http: HttpClient, private alertService: AlertService) { }
}
